export const seatSize = [30, 30];
export const seatState = {
    EMPTY: "empty",
    BOOKED: "booked",
    SELECTED: "selected",
}

export const floors = [
    {
        name: "First Floor",
        imagePath: "/hackathon-seat-booker/floor-1.png",
        imageDim: [828, 404],
        seats: [
            { coord: [45, 73], id: 100, state: seatState.EMPTY },
            { coord: [45, 175], id: 101, state: seatState.EMPTY },
            { coord: [46, 277], id: 102, state: seatState.EMPTY },
            { coord: [198, 277], id: 117, state: seatState.EMPTY },
            { coord: [198, 74], id: 103, state: seatState.BOOKED },
            { coord: [199, 176], id: 104, state: seatState.EMPTY },
            { coord: [336, 74], id: 105, state: seatState.EMPTY },
            { coord: [336, 175], id: 106, state: seatState.BOOKED },
            { coord: [336, 278], id: 107, state: seatState.EMPTY },
            { coord: [489, 74], id: 108, state: seatState.EMPTY },
            { coord: [490, 174], id: 109, state: seatState.EMPTY },
            { coord: [490, 276], id: 110, state: seatState.BOOKED },
            { coord: [625, 73], id: 111, state: seatState.BOOKED },
            { coord: [625, 175], id: 112, state: seatState.EMPTY },
            { coord: [625, 276], id: 113, state: seatState.EMPTY },
            { coord: [781, 277], id: 114, state: seatState.EMPTY },
            { coord: [780, 174], id: 115, state: seatState.EMPTY },
            { coord: [781, 73], id: 116, state: seatState.EMPTY },
        ],
    },
    {
        name: "Second Floor",
        imagePath: "/hackathon-seat-booker/floor-2.png",
        imageDim: [828, 404],
        seats: [
            { coord: [45, 73], id: 100, state: seatState.EMPTY },
            { coord: [45, 175], id: 101, state: seatState.EMPTY },
            { coord: [46, 277], id: 102, state: seatState.EMPTY },
            { coord: [198, 277], id: 117, state: seatState.EMPTY },
            { coord: [198, 74], id: 103, state: seatState.EMPTY },
            { coord: [199, 176], id: 104, state: seatState.EMPTY },
            { coord: [336, 74], id: 105, state: seatState.EMPTY },
            { coord: [336, 175], id: 106, state: seatState.EMPTY },
            { coord: [336, 278], id: 107, state: seatState.EMPTY },
            { coord: [489, 74], id: 108, state: seatState.EMPTY },
            { coord: [490, 174], id: 109, state: seatState.EMPTY },
            { coord: [490, 276], id: 110, state: seatState.EMPTY },
            { coord: [625, 73], id: 111, state: seatState.EMPTY },
            { coord: [625, 175], id: 112, state: seatState.EMPTY },
            { coord: [625, 276], id: 113, state: seatState.BOOKED },
            { coord: [781, 277], id: 114, state: seatState.BOOKED },
            { coord: [780, 174], id: 115, state: seatState.BOOKED },
            { coord: [781, 73], id: 116, state: seatState.BOOKED },
        ],
    },
]